import { FOOD_BENEFIT_STATES } from  'common/domain/constants';

class CardBaseController {
  constructor($location, $translate, EventEmitter) {
    'ngInject';
    this.location = $location;
    this.name = 'cardBase';
    this.states = FOOD_BENEFIT_STATES;
    this.translate = $translate;
    this.EventEmitter = EventEmitter;
  }

  $onInit() {
    this.numberDaysError = this.card.maximumNumberDaysPerMonth;
    this.previousState = this.card.state;
  }

  hasSuccess() {
    return this.card.state === this.states.success;
  }

  hasError() {
    return this.card.state === this.states.error;
  }

  isInitialOrSended() {
    return this.card.state === this.states.initial ||
           this.card.state === this.states.requested ||
           this.card.state === this.states.approved ||
           this.card.state === this.states.modified;
  }

  createPeriod($event) {
    let event = this.EventEmitter($event);
    this.requestFoodBenefits(event);
  }

  notifyEdition($event) {
    this.card = $event;
    let event = this.EventEmitter(this.card);
    this.checkModify(event);
  }

  realoadCardState() {
    let event = this.EventEmitter(this.card);
    this.resetCardState(event);
  }

  isFocused($event) {
    let event = this.EventEmitter($event);
    this.isInEditMode = $event.isFocused;
    this.daysIsFocused(event);

    if ($event.isFocused)
      this.scrollToCurrentCard(this.cardBaseId);
  }

  getContainerCss() {
    return {
      'active': this.isInEditMode,
      'success': this.hasSuccess(),
      'error': this.hasError(),
      'responsiveMobile': this.isMobileApp
    };
  }

  scrollToCurrentCard(id) {
    let page = $('html, body');
    let cardOffset = 75; //px
    let card = $('#' + id).offset().top - cardOffset;
    page.animate({scrollTop: card}, 'slow');
  }
}

export default CardBaseController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/userCardList/userCardRow/homeCard/cardBase/cardBase.controller.js